export default __webpack_public_path__ + "static/media/Heart.1c9cd17e.svg";